<clp-toolbar [title]="('stripe.title' | translate)">
</clp-toolbar>

<section class="stripe-page">
  @if (account$ | async; as account) {
    <div class="stripe-layout">
      <div class="stripe-main">
        <article class="stripe-card stripe-summary stripe-dashboard-card" style="--delay: 0.05s">
          <header class="stripe-summary-header">
            <div class="stripe-summary-title">
              <span class="stripe-overline">{{ 'stripe.accountNumber' | translate }}</span>
              <span class="stripe-account-id">{{ account.id }}</span>
            </div>
            <button type="button" class="clp-btn clp-btn-ghost clp-btn-sm stripe-refresh" (click)="RefreshAccount()">
              <i class="fa-solid fa-rotate-right"></i>
              <span>{{ 'general.refresh' | translate }}</span>
            </button>
          </header>

          <div class="stripe-status-row">
            <span class="stripe-status-chip" [class.is-ok]="account.detailsSubmitted">
              <i class="fa-regular" [ngClass]="account.detailsSubmitted ? 'fa-circle-check' : 'fa-circle-xmark'"></i>
              <span>{{ 'stripe.informationProvided' | translate }}</span>
            </span>
            <span class="stripe-status-chip" [class.is-ok]="account.chargesEnabled">
              <i class="fa-regular" [ngClass]="account.chargesEnabled ? 'fa-circle-check' : 'fa-circle-xmark'"></i>
              <span>{{ 'stripe.chargesEnabled' | translate }}</span>
            </span>
          </div>

          <div class="stripe-metrics-grid">
            <div class="stripe-metric-card">
              <span class="stripe-metric-label">{{ 'stripe.country' | translate }}</span>
              <span class="stripe-metric-value">{{ account.country }}</span>
            </div>
            <div class="stripe-metric-card">
              <span class="stripe-metric-label">{{ 'stripe.defaultCurrency' | translate }}</span>
              <span class="stripe-metric-value">{{ account.defaultCurrency }}</span>
            </div>
          </div>

          @if (!account.detailsSubmitted) {
            <div class="stripe-callout">
              <div class="stripe-callout-body">
                <i class="fa-regular fa-circle-xmark"></i>
                <div>
                  <div class="stripe-callout-title">{{ 'stripe.completeAccount' | translate }}</div>
                  <div class="stripe-callout-text">{{ 'stripe.completeInstructions' | translate }}</div>
                </div>
              </div>
              <button class="clp-btn clp-btn-warning" (click)="CompleteStripeAccount()">{{ 'stripe.completeAccount' | translate}}</button>
            </div>
          }
        </article>

        @if (account.chargesEnabled) {
          <article class="stripe-card stripe-manage" style="--delay: 0.1s">
            <header class="stripe-card-header">
              <div class="stripe-card-title">{{ 'stripe.updateAccount' | translate }}</div>
              <p class="stripe-card-text">{{ 'stripe.updateInstructions' | translate }}</p>
            </header>

            @if (!showUpdateButton) {
              <button class="clp-btn clp-btn-warning stripe-primary" (click)="ShowUpdateStripeAccount()">{{ 'stripe.updateAccount' | translate}}</button>
            }
            @else {
              <div class="stripe-update-inline">
                <form class="stripe-update-form" (ngSubmit)="UpdateStripeAccount(updateForm.value)" [formGroup]="updateForm">
                  <div>
                    <label class="clp-label" for="stripe-code">{{ 'stripe.accountNumber' | translate }}</label>
                    <input class="clp-input" id="stripe-code" formControlName="code">
                  </div>
                  <div class="stripe-update-actions">
                    <button class="clp-btn clp-btn-ghost" type="button" (click)="showUpdateButton = false">{{ 'general.close' | translate }}</button>
                    <button class="clp-btn clp-btn-warning" type="submit">{{'general.save' | translate}}</button>
                  </div>
                </form>
              </div>
            }
          </article>
        }
      </div>

      <div class="stripe-side">
        <article class="stripe-card stripe-timeline" style="--delay: 0.14s">
          <header class="stripe-card-header">
            <div class="stripe-card-title">{{ 'stripe.timelineTitle' | translate }}</div>
            <p class="stripe-card-text">{{ 'stripe.timelineSubtitle' | translate }}</p>
          </header>

          <ol class="stripe-timeline-list">
            <li class="stripe-timeline-item is-complete">
              <span class="stripe-timeline-dot">
                <i class="fa-regular fa-circle-check"></i>
              </span>
              <div class="stripe-timeline-content">
                <span class="stripe-timeline-title">{{ 'stripe.timelineStepAccount' | translate }}</span>
                <span class="stripe-timeline-caption">{{ account.id }}</span>
              </div>
              <span class="stripe-timeline-status is-complete">{{ 'stripe.timelineStatusComplete' | translate }}</span>
            </li>

            <li class="stripe-timeline-item" [class.is-complete]="account.detailsSubmitted" [class.is-pending]="!account.detailsSubmitted">
              <span class="stripe-timeline-dot">
                <i class="fa-regular" [ngClass]="account.detailsSubmitted ? 'fa-circle-check' : 'fa-circle'"></i>
              </span>
              <div class="stripe-timeline-content">
                <span class="stripe-timeline-title">{{ 'stripe.timelineStepDetails' | translate }}</span>
              </div>
              <span class="stripe-timeline-status" [class.is-complete]="account.detailsSubmitted" [class.is-pending]="!account.detailsSubmitted">
                {{ account.detailsSubmitted ? ('stripe.timelineStatusComplete' | translate) : ('stripe.timelineStatusPending' | translate) }}
              </span>
            </li>

            <li class="stripe-timeline-item" [class.is-complete]="account.chargesEnabled" [class.is-pending]="!account.chargesEnabled">
              <span class="stripe-timeline-dot">
                <i class="fa-regular" [ngClass]="account.chargesEnabled ? 'fa-circle-check' : 'fa-circle'"></i>
              </span>
              <div class="stripe-timeline-content">
                <span class="stripe-timeline-title">{{ 'stripe.timelineStepCharges' | translate }}</span>
              </div>
              <span class="stripe-timeline-status" [class.is-complete]="account.chargesEnabled" [class.is-pending]="!account.chargesEnabled">
                {{ account.chargesEnabled ? ('stripe.timelineStatusComplete' | translate) : ('stripe.timelineStatusPending' | translate) }}
              </span>
            </li>
          </ol>
        </article>
      </div>
    </div>
  }
  @else {
    <div class="stripe-grid">
      <article class="stripe-card stripe-setup" style="--delay: 0.05s">
        <header class="stripe-card-header">
          <div class="stripe-card-title">{{ 'stripe.title' | translate }}</div>
          <p class="stripe-card-text">{{ 'stripe.createInstructions' | translate }}</p>
        </header>

        <div class="stripe-steps">
          <div class="stripe-step">
            <div class="stripe-step-index">1</div>
            <div class="stripe-step-body">
              <label class="clp-label" for="stripe-country">{{ 'stripe.selectCountry' | translate }}</label>
              <p class="stripe-hint">{{ 'stripe.selectCountryInstruction' | translate }}</p>
              <select class="clp-select" id="stripe-country" (change)="selectCountry($event)">
                <option [value]=""></option>
                @for (country of countries; track country) {
                  <option [value]="country.value">{{ country.label | translate }}</option>
                }
              </select>
            </div>
          </div>

          @if (showCreateButtons) {
            <div class="stripe-step">
              <div class="stripe-step-index">2</div>
              <div class="stripe-step-body">
                <p class="stripe-hint">{{ 'stripe.createInstructions' | translate }}</p>
                <div class="stripe-actions">
                  <button class="clp-btn clp-btn-ghost" (click)="ShowUpdateStripeAccount()">{{ 'stripe.associateAccount' | translate}}</button>
                  <button class="clp-btn clp-btn-warning" (click)="CreateStripeAccount()">{{ 'stripe.createAccount' | translate}}</button>
                </div>
              </div>
            </div>
          }
        </div>
      </article>
    </div>

    @if (showUpdateButton) {
      <article class="stripe-card stripe-update" style="--delay: 0.16s">
        <header class="stripe-card-header">
          <div class="stripe-card-title">{{ 'stripe.updateAccount' | translate }}</div>
          <p class="stripe-card-text">{{ 'stripe.updateInstructions' | translate }}</p>
        </header>

        <form class="stripe-update-form" (ngSubmit)="UpdateStripeAccount(updateForm.value)" [formGroup]="updateForm">
          <div>
            <label class="clp-label" for="stripe-code">{{ 'stripe.accountNumber' | translate }}</label>
            <input class="clp-input" id="stripe-code" formControlName="code">
          </div>
          <div class="stripe-update-actions">
            <button class="clp-btn clp-btn-ghost" type="button" (click)="showUpdateButton = false">{{ 'general.close' | translate }}</button>
            <button class="clp-btn clp-btn-warning" type="submit">{{'general.save' | translate}}</button>
          </div>
        </form>
      </article>
    }
  }
</section>
